/**
 * ESputnik tracking plugin
 * Загружает и инициализирует скрипт ESputnik для отслеживания событий
 */

export default defineNuxtPlugin(() => {
    if (import.meta.server) return;

    // ESputnik script ID
    const ESPUTNIK_ID = "E1408BE30A554684AEC0C0DD11728671";

    // Загрузка ESputnik скрипта
    const loadESputnikScript = () => {
        // Проверяем, не загружен ли уже скрипт
        if (window.eS) {
            return Promise.resolve();
        }

        return new Promise((resolve, reject) => {
            try {
                // Код загрузки ESputnik согласно документации
                (function (t: any, e: any, c: any, n: any) {
                    var s = e.createElement(c);
                    s.async = 1;
                    s.src = "https://statics.esputnik.com/scripts/" + n + ".js";
                    var r = e.scripts[0];
                    r.parentNode.insertBefore(s, r);
                    var f: any = function () {
                        f.c(arguments);
                    };
                    f.q = [];
                    f.c = function () {
                        f.q.push(arguments);
                    };
                    t["eS"] = t["eS"] || f;

                    // Ожидаем загрузки скрипта
                    s.onload = () => {
                        resolve(true);
                    };
                    s.onerror = () => {
                        reject(new Error("Failed to load ESputnik script"));
                    };
                })(window, document, "script", ESPUTNIK_ID);

                // Инициализируем ESputnik с отключенным автоматическим трекингом
                // так как мы будем отправлять события вручную
                setTimeout(() => {
                    if (window.eS) {
                        window.eS("init", {
                            TRACKING: false, // Отключаем автоматический трекинг
                            RECOMS: true, // Включаем рекомендации
                        });
                        resolve(true);
                    }
                }, 100);
            } catch (error) {
                reject(error);
            }
        });
    };

    // Добавляем глобальную функцию ESputnik в Nuxt app
    return {
        provide: {
            esputnik: {
                // Инициализация
                async init() {
                    await loadESputnikScript();
                },

                // Проверка готовности
                isReady() {
                    return typeof window !== "undefined" && !!window.eS;
                },

                // Отправка события
                sendEvent(eventName: string, data: any) {
                    if (this.isReady()) {
                        try {
                            console.log(`[ESputnik] About to call window.eS("sendEvent", "${eventName}", data):`, data);

                            // Создаем глубокую копию для отслеживания изменений
                            const originalData = JSON.parse(JSON.stringify(data));

                            window.eS("sendEvent", eventName, data);

                            console.log(`[ESputnik] Original data sent:`, originalData);
                            console.log(`[ESputnik] Data after eS call:`, data);
                            console.log(`[ESputnik] Successfully called window.eS("sendEvent", "${eventName}")`);
                        } catch (error) {
                            console.error(`[ESputnik] Failed to send event ${eventName}:`, error);
                        }
                    } else {
                        console.warn("[ESputnik] Script not ready, event not sent:", eventName);
                    }
                },

                // Отправка события с дополнительными тегами
                sendEventWithTags(eventName: string, data: any) {
                    if (this.isReady()) {
                        try {
                            window.eS("sendEventWithTags", eventName, data);
                            console.log(`[ESputnik] Sent event with tags: ${eventName}`, data);
                        } catch (error) {
                            console.error(`[ESputnik] Failed to send event with tags ${eventName}:`, error);
                        }
                    } else {
                        console.warn("[ESputnik] Script not ready, event with tags not sent:", eventName);
                    }
                },
            },
        },
    };
});

// Типы для TypeScript
declare global {
    interface Window {
        eS: any;
    }
}
